
// @ts-nocheck


export const localeCodes =  [
  "at",
  "be",
  "fr-be",
  "ch",
  "fr-ch",
  "de",
  "fi",
  "fr",
  "nl"
]

export const localeLoaders = {
  at: [
    {
      key: "locale_de_45AT_46json_0b285017",
      load: () => import("#nuxt-i18n/0b285017" /* webpackChunkName: "locale_de_45AT_46json_0b285017" */),
      cache: true
    }
  ],
  be: [
    {
      key: "locale_nl_45BE_46json_e600054f",
      load: () => import("#nuxt-i18n/e600054f" /* webpackChunkName: "locale_nl_45BE_46json_e600054f" */),
      cache: true
    }
  ],
  "fr-be": [
    {
      key: "locale_fr_45BE_46json_8232c34a",
      load: () => import("#nuxt-i18n/8232c34a" /* webpackChunkName: "locale_fr_45BE_46json_8232c34a" */),
      cache: true
    }
  ],
  ch: [
    {
      key: "locale_de_45CH_46json_84a88aff",
      load: () => import("#nuxt-i18n/84a88aff" /* webpackChunkName: "locale_de_45CH_46json_84a88aff" */),
      cache: true
    }
  ],
  "fr-ch": [
    {
      key: "locale_fr_45CH_46json_4a0c23c7",
      load: () => import("#nuxt-i18n/4a0c23c7" /* webpackChunkName: "locale_fr_45CH_46json_4a0c23c7" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_45DE_46json_f660f094",
      load: () => import("#nuxt-i18n/f660f094" /* webpackChunkName: "locale_de_45DE_46json_f660f094" */),
      cache: true
    }
  ],
  fi: [
    {
      key: "locale_fi_45FI_46json_893890ae",
      load: () => import("#nuxt-i18n/893890ae" /* webpackChunkName: "locale_fi_45FI_46json_893890ae" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_45FR_46json_3a9591a1",
      load: () => import("#nuxt-i18n/3a9591a1" /* webpackChunkName: "locale_fr_45FR_46json_3a9591a1" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_45NL_46json_6d2d1fd6",
      load: () => import("#nuxt-i18n/6d2d1fd6" /* webpackChunkName: "locale_nl_45NL_46json_6d2d1fd6" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "at",
      iso: "de-AT",
      domain: "",
      files: [
        {
          path: "/app/apps/ags/i18n/langs/de-AT.json",
          cache: undefined
        }
      ]
    },
    {
      code: "be",
      iso: "nl-BE",
      domain: "",
      files: [
        {
          path: "/app/apps/ags/i18n/langs/nl-BE.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr-be",
      iso: "fr-BE",
      domain: "",
      files: [
        {
          path: "/app/apps/ags/i18n/langs/fr-BE.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ch",
      iso: "de-CH",
      domain: "",
      files: [
        {
          path: "/app/apps/ags/i18n/langs/de-CH.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr-ch",
      iso: "fr-CH",
      domain: "",
      files: [
        {
          path: "/app/apps/ags/i18n/langs/fr-CH.json",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      iso: "de-DE",
      domain: "",
      files: [
        {
          path: "/app/apps/ags/i18n/langs/de-DE.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fi",
      iso: "fi-FI",
      domain: "",
      files: [
        {
          path: "/app/apps/ags/i18n/langs/fi-FI.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      iso: "fr-FR",
      domain: "",
      files: [
        {
          path: "/app/apps/ags/i18n/langs/fr-FR.json",
          cache: undefined
        }
      ]
    },
    {
      code: "nl",
      iso: "nl-NL",
      domain: "",
      files: [
        {
          path: "/app/apps/ags/i18n/langs/nl-NL.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "de",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix",
  lazy: true,
  langDir: "langs/",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "at",
    iso: "de-AT",
    domain: "",
    files: [
      {
        path: "/app/apps/ags/i18n/langs/de-AT.json",
        cache: undefined
      }
    ]
  },
  {
    code: "be",
    iso: "nl-BE",
    domain: "",
    files: [
      {
        path: "/app/apps/ags/i18n/langs/nl-BE.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr-be",
    iso: "fr-BE",
    domain: "",
    files: [
      {
        path: "/app/apps/ags/i18n/langs/fr-BE.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ch",
    iso: "de-CH",
    domain: "",
    files: [
      {
        path: "/app/apps/ags/i18n/langs/de-CH.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr-ch",
    iso: "fr-CH",
    domain: "",
    files: [
      {
        path: "/app/apps/ags/i18n/langs/fr-CH.json",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    iso: "de-DE",
    domain: "",
    files: [
      {
        path: "/app/apps/ags/i18n/langs/de-DE.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fi",
    iso: "fi-FI",
    domain: "",
    files: [
      {
        path: "/app/apps/ags/i18n/langs/fi-FI.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    iso: "fr-FR",
    domain: "",
    files: [
      {
        path: "/app/apps/ags/i18n/langs/fr-FR.json",
        cache: undefined
      }
    ]
  },
  {
    code: "nl",
    iso: "nl-NL",
    domain: "",
    files: [
      {
        path: "/app/apps/ags/i18n/langs/nl-NL.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/